// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"9b6b036d","432":"fb38defe","746":"091558ed","824":"3ac29263","854":"6e17bef4"}[chunkId] + ".chunk.js";
};